import _map from 'lodash/map';
import {CancelToken} from 'axios';
import {FeedItem} from '../feedItems/feedItems.types';
import {toStoreFeedItem} from '../feedItems/feedItems.dataConverters';
import apiV2Service from '../api/api-v2.service';
import {ResponseMetaData} from '../api/apiTypes';

const basePath = `LocationFeedItems`;

export interface GetLocationFeedItemsProps {
  locationFeedId: number;
  locationSetId?: number;
  query?: string;
  startIndex?: number;
  count?: number;
  cancelToken?: CancelToken;
}

async function getFeedItems({
  locationFeedId,
  query,
  startIndex,
  count,
  cancelToken,
}: GetLocationFeedItemsProps) {
  const params = apiV2Service.cleanEmptyValues({
    locationFeedId,
    query,
    startIndex,
    count,
  });
  const {
    data: {businessesFound, dynamicTableMetaData},
  } = await apiV2Service.executePutRequest<{
    businessesFound: FeedItem[];
    dynamicTableMetaData: ResponseMetaData;
  }>(
    `${basePath}/SearchItems2`,
    {},
    {
      cancelToken,
      ...params,
    },
  );

  return {
    feedItems: _map(businessesFound, toStoreFeedItem),
    meta: dynamicTableMetaData,
  };
}

async function getLocationsByIds(locationFeedId: number, locationIds: string[]) {
  const {data: result} = await apiV2Service.executePostRequest<{items: FeedItem[]}>(
    `${basePath}/${locationFeedId}/GetByIds`,
    {},
    {itemIds: locationIds},
  );

  return result.items;
}

const locationFeedItemsApi = {
  getFeedItems,
  getLocationsByIds,
};

export default locationFeedItemsApi;
